import { gl } from '../../Engine';

export function contentToBitmap(): ImageBitmap {
    const offscreenCanvas = gl.canvas as OffscreenCanvas;
    return offscreenCanvas.transferToImageBitmap();
}

/**
 * Empty the GL error queue, discarding anything pending, so that an error
 * found afterwards belongs to the work issued in between.
 */
export function discardPendingGlErrors(): void {
    while (gl.getError() !== gl.NO_ERROR) {
        // Each read takes one error off the queue.
    }
}

/**
 * Empty the GL error queue, throwing with `context` if anything was
 * pending. Call before an operation whose own error code is about to
 * be inspected: it leaves the queue clean so that code is
 * attributable, while reporting rather than discarding a failure
 * raised by the preceding work.
 */
export function assertNoPendingGlError(context: string): void {
    const firstError = gl.getError();
    if (firstError === gl.NO_ERROR) {
        return;
    }
    discardPendingGlErrors();
    throw new Error(`${context} raised GL error 0x${firstError.toString(16)}`);
}

/**
 * Throws with `context` when GL work already issued cannot be trusted to
 * have reached the GPU: the context is lost, or an error is pending. WebGL
 * reports a failed allocation or upload only this way, never by throwing.
 */
export function assertGlWorkLanded(context: string): void {
    if (gl.isContextLost()) {
        throw new Error(`${context}: GL context lost`);
    }
    assertNoPendingGlError(context);
}
